// This form is used in all login help options other than "forgot login Id"

import * as React from "react";
import { checkPasswordStranth } from "../../utils/regex";
import EdButton from "../../generic/edButton";
import "../../../assets/scss/Login/login/generic/loginInput.scss";
import "../../../assets/scss/Login/login/forms/forgotLoginIdForm.scss";

import LoginErrMsg from "../generic/loginErrMsg";
import ConfirmPassword from "../../generic/confirmPassword";
import { passwordHints } from "../../../Containers/Constants/commenFeatures";

export interface IResetPasswordFormProps {
  onSuccess: (values: IResetPasswordFields) => void; // function to be called on the success of called apis
  errors: string;
  onRemoveError: () => void; // removes the errorMsg
}

// form fields
export interface IResetPasswordFields {
  password: string;
  confirmPassword: string;
}

const ResetPassword: React.FC<IResetPasswordFormProps> = (props) => {
  const [showPasswordHint, setShowPasswordHint] = React.useState<Array<string>>(
    []
  );
  // used to store the entered values in form
  const [values, setValues] = React.useState<IResetPasswordFields>({
    password: "",
    confirmPassword: "",
  });

  // used to store the field wise errors
  const [errors, setErrors] = React.useState<{
    [key in keyof IResetPasswordFields]?: string;
  }>({
    password: undefined,
    confirmPassword: undefined,
  });

  // used to store if the form is submitted or not
  const [submitted, setSubmitted] = React.useState(false);

  function handleSubmit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    setSubmitted(true);
    props.onSuccess(values);
  }

  React.useEffect(() => {
    let listOfStr: Array<string> = [];
    let getStrength;
    if (values.password.length === 0) {
      getStrength = passwordHints;
    } else {
      getStrength = checkPasswordStranth(6, 12, values.password);
    }
    for (let list in getStrength) {
      if (getStrength[list] !== "") {
        listOfStr.push(getStrength[list]);
      }
    }

    setShowPasswordHint(listOfStr);
  }, [values.password]);

  React.useEffect(() => {
    if (showPasswordHint.length === 0 || !values.password) {
      setErrors({
        ...errors,
        password: "",
      });
    }
  }, [showPasswordHint]);

  React.useEffect(() => {
    if (values) {
      props.onRemoveError();
    }
  }, [values]);

  return (
    <div className="login_form">
      <form>
        <ConfirmPassword
          form={values}
          error={errors}
          showPasswordHint={showPasswordHint}
          onChange={setValues}
          setError={setErrors}
        />
        {props.errors ? (
          <LoginErrMsg className="mg-b40">{props.errors}</LoginErrMsg>
        ) : (
          <div className="mg-b40"></div>
        )}

        <EdButton
          value={"Change Password"}
          btnTyp="primary"
          className="submit_btn "
          // Disable if there is even one error or if any field is empty or if form is submitted
          disabled={
            Object.values(errors).every((error) => error) ||
            Object.values(values).some((value) => !value) ||
            submitted
          }
          onClick={handleSubmit}
        />
      </form>
    </div>
  );
};

export default ResetPassword;
